import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuWorkOrderSlottingView } from "src/tenantCustomizations/tenants/mellano/views/luukku/slotting/MellanoLuukkuWorkOrderSlottingView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/workOrderSlotting")({
	staticData: { title: "Ruudutus", legacyViewKey: "mellanoLuukkuWorkOrderSlottingView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuWorkOrderSlottingView />;
}
